class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.addEventListener('click', this._onBackdropClick);
    this.setHeaderCartIconAccessibility();
  }

  _onBackdropClick(event) {
    if (!this.classList.contains('active')) return;
    const inner = this.querySelector('.drawer__inner');
    if (!inner || inner.contains(event.target)) return;
    this.close();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);

    if (this._trapFocusFallbackId) {
      clearTimeout(this._trapFocusFallbackId);
      this._trapFocusFallbackId = null;
    }
    if (this._onTransitionEndTrap) {
      this.removeEventListener('transitionend', this._onTransitionEndTrap);
    }

    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    let trapFocusRan = false;
    const runTrapFocusOnce = () => {
      if (trapFocusRan) return;
      trapFocusRan = true;
      if (this._trapFocusFallbackId) {
        clearTimeout(this._trapFocusFallbackId);
        this._trapFocusFallbackId = null;
      }
      this.removeEventListener('transitionend', this._onTransitionEndTrap);
      const inner = this.querySelector('.drawer__inner');
      const containerToTrapFocusOn = inner || document.getElementById('CartDrawer');
      const focusElement = this.classList.contains('is-empty')
        ? this.querySelector('.drawer__header .drawer__close') || inner
        : inner || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    };

    this._onTransitionEndTrap = () => runTrapFocusOnce();
    this.addEventListener('transitionend', this._onTransitionEndTrap);

    // If transitionend never fires (reduced motion, display:none, etc.), still trap focus.
    this._trapFocusFallbackId = setTimeout(runTrapFocusOnce, 350);

    document.body.classList.add('overflow-hidden');
  }

  close() {
    if (this._trapFocusFallbackId) {
      clearTimeout(this._trapFocusFallbackId);
      this._trapFocusFallbackId = null;
    }
    if (this._onTransitionEndTrap) {
      this.removeEventListener('transitionend', this._onTransitionEndTrap);
    }
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const el = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return el ? el.innerHTML : '';
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
